export const defaultVatCoefficient = 10000;
export const defaultVatMultiplier = 100;
